//DEFAULTS
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

//import $ from 'imports/jquery'
//import stickOverlay from 'site/overlay'
import stickSite from 'site/site'
import stickGlobal from 'site/global'
import galleryFeatured from 'site/galleryFeatured'
import bookingWidget from 'site/bookingWidget'
import stickScroll from 'site/stickScroll'
import mobileNav from 'site/mobileNav';
import simpleSlideshowPrep from "site/simpleSlideshowPrep";
$(document).ready(function() {
    //stickOverlay.init()
    stickSite.init()
    stickGlobal.init()
    galleryFeatured.init()
    mobileNav.init()
    stickScroll.init()
    simpleSlideshowPrep.init()
    bookingWidget.init()
})
